import createLucideIcon from '../createLucideIcon';

const Minus = createLucideIcon('Minus', [
  ['line', { x1: '5', x2: '19', y1: '12', y2: '12', key: '13b5wn' }],
]);

export default Minus;
